import React, { useEffect, useState, useMemo } from "react";
import { DatePickerFeild } from '../../components/reactHookFormFields/datePicker';
import { useForm, useWatch } from 'react-hook-form';
import moment from 'moment';
import MainPageDialog from '../../components/dialog';
import { useCreateCcmBillingMutation, useGetBillingActivitiesQuery, useGetAllProviderQuery } from '../../services/chatService';
import { toast } from "react-toastify";
import { PageDialogContent } from "../../components/dialog";
import { useGroupChatContext } from '../../context/groupchatContext';
import {ReactSelectField} from '../../components/reactHookFormFields/selectField'
import { BtnComponent } from "../../components/button";

function StopWatchPopup({
    onCancelHandler,
    setIsStopwatchPaused,
    formState,
    setFormState,
    startTime,
    setStartTime

}) {
    const { control ,formState: { errors }, reset, setValue} = useForm({
        defaultValues: { date: moment(),activity: formState.activity,provider: formState.provider },
    });

    const searchProvider = useWatch({ control: control, name: "provider" });
    const searchActivity = useWatch({ control: control, name: "activity" });
    const groupChatContext = useGroupChatContext();
    const {authData, selectedChat, setElapsedTime,elapsedTime,isStopwatchActive, setIsStopwatchActive} = useMemo(() => ({
        authData: groupChatContext.authData,
        selectedChat: groupChatContext.selectedChat,
        elapsedTime: groupChatContext.elapsedTime,
        setElapsedTime: groupChatContext.setElapsedTime,
        isStopwatchActive: groupChatContext.isStopwatchActive,
        setIsStopwatchActive: groupChatContext.setIsStopwatchActive,
    }));

    const {data: Activities} = useGetBillingActivitiesQuery();
    const {data: providers } = useGetAllProviderQuery();

    const [isOpenDiscardPopup, setIsOpenDiscardPopup] = useState(false);

    const handlePause = () => {
        setIsStopwatchActive(false);
        setIsStopwatchPaused(true);
        updateFormStateWithElapsedTime();
    };

    const handleStart = () => {
        setIsStopwatchActive(true);
        setIsStopwatchPaused(false);
        setStartTime(Date.now() - getTotalElapsedTimeInMilliseconds(elapsedTime));
        onCancelHandler();
    };

    const handleStop = () => {
        setIsStopwatchActive(false);
        setIsStopwatchPaused(true);
        updateFormStateWithElapsedTime();
    };

    const handleReset = () => {
        setIsStopwatchActive(false);
        setIsStopwatchPaused(true);
        setElapsedTime({ hours: 0, minutes: 0, seconds: 0 });
        reset({
            ...formState,
            activity: '',
            provider: '',
        });
        setFormState({
            ...formState,
            hours: '00',
            minutes: '00',
            seconds: '00',
        });
    };

    const updateFormStateWithElapsedTime = () => {
        setFormState({
            ...formState,
            hours: formatTime(elapsedTime.hours),
            minutes: formatTime(elapsedTime.minutes),
            seconds: formatTime(elapsedTime.seconds)
        });
    };

    const formatTime = (timeValue) => {
        return timeValue.toString().padStart(2, '0');
    };

    const handleSelectChange = (selectedOption) => {
        setFormState({
            ...formState,
            activity: selectedOption
        });
    };

    const handleDateChange = (selectedOption) => {
        setFormState({
            ...formState,
            date: selectedOption
        });
    };

    const handleProviderChange = (selectedOption) => {
        setFormState({
            ...formState,
            provider: selectedOption
        });
    };

    const handleComment = (e) => {
        const { name, value } = e.target;
        setFormState({ ...formState, [name]: value });
    };

    const [createCcmBilling, {isLoading}] = useCreateCcmBillingMutation();
    const handleSubmit = (e) => {
        e.preventDefault();
        const billDate = new Date(formState.date);
        const formattedBillDate = billDate.toISOString().split('T')[0];
        const payload = {description: formState.comments,
                        pid: selectedChat.pid,
                        provider_id: formState.provider.value,
                        secs:(((elapsedTime.hours)*3600)+((elapsedTime.minutes)*60)+(elapsedTime.seconds)),
                        entity_action: formState.activity.label,
                        entity_id: formState.activity.value,
                        bill_date: formattedBillDate,
                        encounter: 0
                    }
        createCcmBilling(payload).then((res) => {
            toast.success(res.data.response.msg);
            handleReset();
            onCancelHandler();
        });
    };
    const handleFocus = (e) => {
        e.target.select();
    };

    const handleTimeChange = (e) => {
        const { name, value } = e.target;
        if (value === '' || /^[0-9\b]{0,2}$/.test(value)) {
            setFormState({
                ...formState,
                [name]: value
            });

            setElapsedTime({
                ...elapsedTime,
                [name]: value === '' ? 0 : parseInt(value)
            });
        }
    };

    const footerlist=[
        {
        title: "Close",
        action: () => {
            setIsOpenDiscardPopup(false);
        },
        type: "cancel",
        },
        {
            title: "Discard",
            action: () => {
                setIsOpenDiscardPopup(false);
                handleReset();
            },
            type: "save",
            },
    ]

    const activityOptions = Activities?.map(activity => ({
        value: activity.id,
        label: activity.title
    }));

    const providerOptions = providers?.map(provider => ({
        value: provider.User.id,
        label: provider.User.name
    }));

    const isButtonDisabled = () => {
        const isElapsedTimeZero = elapsedTime.hours === 0 && elapsedTime.minutes === 0 && elapsedTime.seconds === 0;
        return isElapsedTimeZero || (isStopwatchActive && !isElapsedTimeZero);
    };

    const getTotalElapsedTimeInMilliseconds = (elapsedTime) => {
        return (elapsedTime.hours * 3600 + elapsedTime.minutes * 60 + elapsedTime.seconds) * 1000;
    };
    
    useEffect(() => {
        let intervalId;
        if (isStopwatchActive) {
            intervalId = setInterval(() => {
                const now = Date.now();
                const diff = now - startTime;
                const hours = Math.floor(diff / 3600000);
                const minutes = Math.floor((diff % 3600000) / 60000);
                const seconds = Math.floor((diff % 60000) / 1000);

                setElapsedTime({ hours, minutes, seconds });
            }, 1000);
        }
        if (providerOptions) {
            const defaultProvider = providerOptions.find(provider => provider.value === authData.id);
            setValue('provider', defaultProvider);
            setFormState({
                ...formState,
                provider: defaultProvider
            });
        }
        isButtonDisabled();
        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
            document.body.style.overflow = 'auto';
        };
    }, [isStopwatchActive, providerOptions]);

    return (
        <>
            <PageDialogContent>
                <div>
                    <form id="stopWatchForm" name="stopWatchForm" onSubmit={handleSubmit}>
                        <DatePickerFeild
                            title="Date"
                            control={control}
                            name="date"
                            dateTime={false}
                            isDisabled={isStopwatchActive}
                            onChange={handleDateChange}
                        />

                        <div className="form-group">
                            
                            <ReactSelectField
                                title="Activity"
                                name="activity"
                                control={control}
                                optionData={activityOptions?.map((v, k) => ({
                                    ...v,
                                    label: v.label,
                                }))}
                                onChange={handleSelectChange}
                                isDisabled={isStopwatchActive}
                                rules={{
                                    required: {value: true},
                                }}
                                errors={errors}
                            />
                        </div>

                        <div className="form-group">
                            
                            <ReactSelectField
                                title="Provider"
                                name="provider"
                                control={control}
                                isDisabled={isStopwatchActive}
                                optionData={providerOptions?.map((v, k) => ({
                                    ...v,
                                    label: v.label,
                                }))}
                                onChange={handleProviderChange}
                                rules={{
                                    required: {value: true},
                                }}
                                errors={errors}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="comments">Comments:</label>
                        
                            <input
                                type="text"
                                name="comments"
                                id="comments"
                                className="border border-gray bg-white rounded custom-input"
                                style={{ height: "60px", width: "100%" }}
                                value={formState.comments}
                                onChange={handleComment}
                                isDisabled={isStopwatchActive}
                            />
                        </div>

                        {!isStopwatchActive ?
                            <div className="row text-center">
                                <div className="form-group d-flex justify-content-between" style={{ display: "flex", justifyContent: "center" }}>
                                    <div style={{ display: "inline-grid" }}>
                                        <label style={{ margin: "25px 25px 0 25px" , fontSize: "18px", color: "gray"}}>Hours</label>
                                        <input
                                            type="text"
                                            name="hours"
                                            id="hours"
                                            value={formState.hours}
                                            style={{ margin: "10px 25px", width: "45px",height: "40px", border: "1px solid gray", textAlign: "center" }}
                                            onChange={handleTimeChange}
                                            onFocus={handleFocus}
                                            className="form-control onlyNumeric timeInputs"
                                            placeholder="00"
                                            maxLength="2"
                                            autoComplete="off"
                                        />
                                    </div>
                                    <div style={{ display: "inline-grid" }}>
                                        <label style={{ margin: "25px 25px 0 25px" , fontSize: "18px", color: "gray"}}>Mins</label>
                                        <input
                                            type="text"
                                            name="minutes"
                                            id="minutes"
                                            value={formState.minutes}
                                            style={{ margin: "10px 25px", width: "45px",height: "40px", border: "1px solid gray", textAlign: "center" }}
                                            onChange={handleTimeChange}
                                            onFocus={handleFocus}
                                            className="form-control onlyNumeric timeInputs"
                                            placeholder="00"
                                            maxLength="2"
                                            autoComplete="off"
                                        />
                                    </div>
                                    <div style={{ display: "inline-grid" }}>
                                        <label style={{ margin: "25px 25px 0 25px" , fontSize: "18px", color: "gray"}}>Secs</label>
                                        <input
                                            type="text"
                                            name="seconds"
                                            id="seconds"
                                            value={formState.seconds}
                                            style={{ margin: "10px 25px", width: "45px",height: "40px", border: "1px solid gray", textAlign: "center" }}
                                            onChange={handleTimeChange}
                                            onFocus={handleFocus}
                                            className="form-control onlyNumeric timeInputs"
                                            placeholder="00"
                                            maxLength="2"
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>
                            </div> :
                            <div className="stopwatch-display">
                                <strong>{formatTime(elapsedTime.hours)}:{formatTime(elapsedTime.minutes)}:{formatTime(elapsedTime.seconds)}</strong> 
                            </div>
                        }

                        <div className="timer-form ">
                            <BtnComponent type="submit" text="LogTime" loading={isLoading} disabled={isButtonDisabled() || isLoading}/>
                            {!isStopwatchActive?<BtnComponent text="Start" disabled={!searchProvider || !searchActivity} onClick={handleStart}/>:null}
                            {isStopwatchActive?<BtnComponent text="Pause" btnType="default" onClick={handlePause}/>:null}
                            {!isStopwatchActive?<BtnComponent text="Stop" btnType="default" disabled={isButtonDisabled()} onClick={handleStop}/>:null}
                            <BtnComponent text="Reset" btnType="chief" disabled={isButtonDisabled()} onClick={handleReset}/>
                            <BtnComponent text="Discard" btnType="danger" disabled={isButtonDisabled()} onClick={() => setIsOpenDiscardPopup(true)}/>
                        </div>
                    </form>
                </div>
            </PageDialogContent>
            {isOpenDiscardPopup ?
                <MainPageDialog
                    title="Warning!"
                    footerList={footerlist}
                    modalSize="md"
                    maxHeight={true}
                    onCancelHandler={() => setIsOpenDiscardPopup(false)}
                >
                    <div className="px-3 py-5  text-left text-lg text-gray-900">
                        <p>Are you sure you wants to discard the Timer?</p>
                    </div>
                </MainPageDialog>
                : null
            }
        </>
    );
}

export default StopWatchPopup;
